<template>
  <div class="rss-widget" :style="style">
    <RssViewer :setting="rssSetting" @saveData="saveAppData" />
  </div>
</template>

<script>
  import RssViewer from '@/components/rssViewer/RssViewer.vue';

  import { simpleTypeMixin } from '@/helpers';
  import templateWidget from '@/components/widgets/templates/mixins/templateWidget';

  import { SET_APP_DATA } from '@/store/actions/player';

  export default {
    name: 'RssWidget',

    mixins: [simpleTypeMixin, templateWidget],

    components: {
      RssViewer,
    },

    props: {
      widget: {
        type: Object,
        required: true,
      },
    },

    computed: {
      style() {
        return Object.assign({}, this.defaultStyling(this.widget), {
          overflow: 'hidden',
        });
      },

      rssSetting() {
        return {
          appId: this.widget.object.wid,
          rssLink: this.widget.object.link,
          rssTheme: this.widget.object.theme,
          rssDuration: this.widget.object.display.duration || 15,
          display: this.widget.object.display,
        };
      },
    },

    methods: {
      saveAppData(data = null) {
        this.$store.commit(SET_APP_DATA, {
          appId: this.widget.object.wid,
          appData: { appType: 'rss', data },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .rss-widget {
    position: absolute;
    overflow: hidden;
  }
</style>
